import React, { Component } from "react";
import PropTypes from "prop-types";
import FormControl from "../FormControl";
import { CheckRule } from "../../common";
import _ from "lodash";

class FormSectionControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formControls: []
    };
  }

  getFormSections(formControlsFiltered) {
    let unsupportedControls = 0;
    formControlsFiltered.forEach((formControl, index) => {
      let controlError = _.filter(this.props.errors, {
        element_id: Number(formControl.element_id)
      });
      let err = false;
      if (controlError.length === 1) {
        err = controlError[0].required;
      }

      let controlLoading = _.filter(this.props.isLoading, {
        element_id: Number(this.props.formControl.element_id)
      });
      let load = false;

      if (controlLoading.length === 1) {
        load = controlLoading[0].loading;
      }

      let repeatingFormId = this.props.repeatingFormId;
      let repeatingFormUUID = this.props.repeatingFormUUID;

      let repeatingFormEdit = this.props.repeatingFormEdit;

      let element = _.filter(this.props.draft, function(draft) {
        return (
          Number(draft.element_id) === Number(formControl.element_id) &&
          draft.repeatingFormId ===
            (repeatingFormId !== -1 ? repeatingFormId : undefined) &&
          draft.repeatingFormUUID ===
            (repeatingFormUUID !== -1 ? repeatingFormUUID : undefined)
        );
      });

      if (element.length > 1) {
        element = _.filter(element, function(draft) {
          return (
            draft.repeatingFormEdit ===
            (repeatingFormEdit === undefined ? undefined : repeatingFormEdit)
          );
        });
      }

      let parentVisible = true;
      let element2 = "";
      let value_x = "";
      let show = "";
      let p2 = formControl.element_parent;

      for (let index = 0; index < 10; index++) {
        let parent = _.filter(formControlsFiltered, function(draft) {
          return Number(draft.element_id) === Number(p2);
        });

        element2 = "";
        value_x = "";
        show = "";
        if (parent.length === 1 && parentVisible === true) {
          p2 = parent[0].element_parent;
          switch (parent[0].element_condition.action) {
            case "":
              parentVisible = true;
              break;
            case "show":
              parent[0].element_condition.roles.forEach(elementr => {
                element2 = _.filter(this.props.draft, function(draft) {
                  return (
                    Number(draft.element_id) === Number(elementr.c_control)
                  );
                });

                if (element2.length === 1) {
                  let uid = this.props.repeatingFormUUID;

                  element2 = _.filter(element2, function(draft) {
                    //return draft.repeatingFormEdit === true;
                    return draft.repeatingFormUUID === uid;
                  });
                  if (element2.length > 0) {
                    value_x = element2[0].element_value;
                  }
                } else {
                  if (element2.length > 1) {
                    element2 = _.filter(element2, function(draft) {
                      return draft.repeatingFormEdit === true;
                    });

                    if (element2.length > 0) {
                      if (element2.length > 1) {
                        element2 = _.filter(element2, function(draft) {
                          return draft.repeatingFormEdit === true;
                        });

                        value_x = element2[0].element_value;
                      } else {
                        value_x = element2[0].element_value;
                      }
                    }
                  }
                }

                show = CheckRule(show, value_x, elementr);
              });
              if (show === "") {
                show = false;
              } else {
                show = (" " + show).replace("  && ", "").replace("  || ", "");
              }
              if (!eval(show)) {
                parentVisible = false;
              }

              break;
            case "hide":
              parent[0].element_condition.roles.forEach(elementr => {
                element2 = _.filter(this.props.draft, function(draft) {
                  return (
                    Number(draft.element_id) === Number(elementr.c_control)
                  );
                });

                if (element2.length === 1) {
                  let uid = this.props.repeatingFormUUID;

                  element2 = _.filter(element2, function(draft) {
                    return draft.repeatingFormUUID === uid;
                  });
                  if (element2.length > 0) {
                    value_x = element2[0].element_value;
                  }
                } else {
                  if (element2.length > 1) {
                    element2 = _.filter(element2, function(draft) {
                      return draft.repeatingFormEdit === true;
                    });

                    if (element2.length > 0) {
                      if (element2.length > 1) {
                        element2 = _.filter(element2, function(draft) {
                          return draft.repeatingFormEdit === true;
                        });
                        value_x = element2[0].element_value;
                      } else {
                        value_x = element2[0].element_value;
                      }
                    }
                  }
                }

                show = CheckRule(show, value_x, elementr);
              });
              if (show === "") {
                show = false;
              } else {
                show = (" " + show).replace("  && ", "").replace("  || ", "");
              }
              if (eval(show)) {
                parentVisible = false;
              }

              break;
          }
        } else {
          break;
        }
      }

      let value = "";

      if (element.length === 1) {
        value = element[0].element_value;
      }

      let newIndex = index + 2 - unsupportedControls;

      element = "";
      value_x = "";
      show = "";
      switch (formControl.element_condition.action) {
        case "":
          if (parentVisible) {
            this.state.formControls.push(
              <FormControl
                repeatingFormUUID={repeatingFormUUID}
                setMandatory={this.props.setMandatory}
                section={this.props.index}
                ref={"formControl" + newIndex}
                next={true}
                onNavNext={this.props.onNavNext}
                index={newIndex}
                repeatingForm={this.props.repeatingForm}
                storeColour={this.props.storeColour}
                isLoading={load}
                page={this.props.page}
                validate={this.props.validate}
                error={err}
                {...this.props.draft}
                {...formControl}
                element_value={value}
                onChange={this.props.onChange}
                key={newIndex}
              />
            );
          }
          break;
        case "show":
          formControl.element_condition.roles.forEach(elementr => {
            element = _.filter(this.props.draft, function(draft) {
              return Number(draft.element_id) === Number(elementr.c_control);
            });

            if (element.length === 1) {
              let uid = this.props.repeatingFormUUID;

              element = _.filter(element, function(draft) {
                return draft.repeatingFormUUID === uid;
              });
              if (element.length > 0) {
                value_x = element[0].element_value;
              }
            } else {
              if (element.length > 1) {
                let uid = this.props.repeatingFormUUID;

                element = _.filter(element, function(draft) {
                  return draft.repeatingFormUUID === uid;
                });

                if (element.length > 0) {
                  if (element.length > 1) {
                    element = _.filter(element, function(draft) {
                      return draft.repeatingFormEdit === true;
                    });
                    value_x = element[0].element_value;
                  } else {
                    value_x = element[0].element_value;
                  }
                }
              }
            }

            show = CheckRule(show, value_x, elementr);
          });
          if (show === "") {
            show = false;
          } else {
            show = (" " + show).replace("  && ", "").replace("  || ", "");
          }
          if (eval(show) && parentVisible) {
            this.state.formControls.push(
              <FormControl
                repeatingFormUUID={repeatingFormUUID}
                setMandatory={this.props.setMandatory}
                section={this.props.index}
                ref={"formControl" + newIndex}
                next={true}
                onNavNext={this.props.onNavNext}
                index={newIndex}
                repeatingForm={this.props.repeatingForm}
                storeColour={this.props.storeColour}
                isLoading={load}
                page={this.props.page}
                validate={this.props.validate}
                error={err}
                {...this.props.draft}
                {...formControl}
                element_value={value}
                onChange={this.props.onChange}
                key={newIndex}
              />
            );
          }

          break;
        case "hide":
          formControl.element_condition.roles.forEach(elementr => {
            element = _.filter(this.props.draft, function(draft) {
              return Number(draft.element_id) === Number(elementr.c_control);
            });

            if (element.length === 1) {
              let uid = this.props.repeatingFormUUID;

              element = _.filter(element, function(draft) {
                return draft.repeatingFormUUID === uid;
              });
              if (element.length > 0) {
                value_x = element[0].element_value;
              }
            } else {
              if (element.length > 1) {
                let uid = this.props.repeatingFormUUID;
                element = _.filter(element, function(draft) {
                  return draft.repeatingFormUUID === uid;
                });
                if (element.length > 0) {
                  if (element.length > 1) {
                    element = _.filter(element, function(draft) {
                      return draft.repeatingFormEdit === true;
                    });
                    value_x = element[0].element_value;
                  } else {
                    value_x = element[0].element_value;
                  }
                }
              }
            }

            show = CheckRule(show, value_x, elementr);
          });
          if (show === "") {
            show = false;
          } else {
            show = (" " + show).replace("  && ", "").replace("  || ", "");
          }
          if (!eval(show) && parentVisible) {
            this.state.formControls.push(
              <FormControl
                repeatingFormUUID={repeatingFormUUID}
                setMandatory={this.props.setMandatory}
                section={this.props.index}
                ref={"formControl" + newIndex}
                next={true}
                onNavNext={this.props.onNavNext}
                index={newIndex}
                repeatingForm={this.props.repeatingForm}
                storeColour={this.props.storeColour}
                isLoading={load}
                page={this.props.page}
                validate={this.props.validate}
                error={err}
                {...this.props.draft}
                {...formControl}
                element_value={value}
                onChange={this.props.onChange}
                key={newIndex}
              />
            );
          }

          break;
      }
    });
  }

  render() {
    this.state.formControls = [];
    this.getFormSections(this.props.formControls);

    if (this.state.formControls.length > 0) {
      return <div>{this.state.formControls}</div>;
    }

    return null;
  }
}

FormSectionControl.propTypes = {
  formControls: PropTypes.array.isRequired,
  formControl: PropTypes.object.isRequired,
  draft: PropTypes.array.isRequired,
  element_value: PropTypes.string.isRequired,
  errors: PropTypes.array.isRequired,
  isLoading: PropTypes.array.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  repeatingForm: PropTypes.bool,
  repeatingFormId: PropTypes.number,
  repeatingFormEdit: PropTypes.bool,
  repeatingFormUUID: PropTypes.number,
  page: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default FormSectionControl;



// WEBPACK FOOTER //
// ./src/components/FormSectionControl/index.js